import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {LoginResponseDto} from "../models/auth.model";
import {HttpClient} from "@angular/common/http";
import {AppState} from "../../reducers/reducer";
import {Store} from "@ngrx/store";
import {catchError, throwError} from "rxjs";
import {tap} from "rxjs/operators";
import {logout, storeTokens} from "../actions/auth.actions";
import {UserRoles} from "../../shared/enum/user-roles.enum";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public static tripsRoles = [UserRoles.POI_WRITE, UserRoles.POI_READ, UserRoles.IMAGE_READ];

  private BASE_ROUTE = '/auth/';
  private LOGIN = this.BASE_ROUTE + 'login';
  private LOGOUT = this.BASE_ROUTE + 'logout';
  private REFRESH_TOKENS = this.BASE_ROUTE + 'refresh-tokens';

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) { }

  login(username: string, password: string) {
    const url = `${environment.BASE_PATH}${this.LOGIN}`;
    return this.http.post<LoginResponseDto>(`${url}`, { username, password });
  }

  refreshTokens() {
    console.log('parte richiesta refresh'); // Il problema è che le richieste di refresh dopo la prima partono prima ancora che la prima abbia successo
    localStorage.setItem('isRefreshing', JSON.stringify(true));

    const url = `${environment.BASE_PATH}${this.REFRESH_TOKENS}`;
    const refreshToken = AuthService.getRefreshTokenFromLS();
    const user = AuthService.getUserFromLS();

    return this.http.post<LoginResponseDto>(url, { user, refreshToken }).pipe(
      tap((response: LoginResponseDto) => {
        console.log('token refresh fatto');
        localStorage.setItem('isRefreshing', JSON.stringify(false));
        return this.store.dispatch(storeTokens(response));
      }),
      catchError(e => {
        localStorage.setItem('isRefreshing', JSON.stringify(false));
        this.store.dispatch(logout());
        return throwError(e);
      })
    );
  }

  logout() {
    const refreshToken = AuthService.getRefreshTokenFromLS();
    const url = `${environment.BASE_PATH}${this.LOGOUT}`;
    return this.http.post<boolean>(url, { refreshToken: refreshToken });
  }

  private static getRefreshTokenFromLS() {
    return JSON.parse(localStorage.getItem('refresh') || '{}');
  }

  private static getUserFromLS() {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }

  public static canSeeTrips(roles: UserRoles[]) : boolean {
    if(!roles) return false;
    if(roles.includes(UserRoles.ADMIN)) return true;

    for(const tripRole of this.tripsRoles) {
      if(!roles.includes(tripRole)) {
        return false;
      }
    }
    return true;
  }

  public static hasAllRoles(requiredRoles: string[], roles: string[]) : boolean {
    if (requiredRoles) {
      if (roles) {
        if (roles.includes(UserRoles.ADMIN)) {
          // ADMIN can do anything
          return true;
        }
        for (const requiredRole of requiredRoles) {
          if (!roles.includes(requiredRole)) {
            console.log("non si puòòòò")
            return false;
          }
        }
        // all roles matched
        return true;
      } else {
        // no roles at all
        return false;
      }
    } else {
      return true;
    }
  }
}
